var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSection1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.1224 31.1666C16.947 31.1666 16.7716 31.1264 16.6133 31.0444L11.5117 28.4036C10.0641 27.6534 8.93173 26.8116 8.04748 25.8309C6.11211 23.686 5.03532 20.9326 5.01821 18.0765L4.95831 8.67602C4.95117 7.59108 5.65144 6.61727 6.69828 6.25053L16.0656 2.9846C16.6219 2.78595 17.2423 2.78317 17.8085 2.97487L27.2115 6.12967C28.264 6.48113 28.9757 7.44799 28.9814 8.53154L29.0413 17.939C29.0598 20.791 28.0201 23.5554 26.1147 25.7239C25.2404 26.7185 24.118 27.5729 22.6847 28.3369L17.6288 31.0375C17.4719 31.1222 17.2979 31.1653 17.1224 31.1666",
    fill: "#3C7CF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0353 20.288C15.7615 20.2893 15.4877 20.1907 15.2766 19.9879L12.5611 17.3763C12.1418 16.9706 12.1375 16.3122 12.5525 15.9037C12.9675 15.4939 13.645 15.4898 14.0657 15.894L16.0196 17.7722L20.7903 13.0685C21.2068 12.6587 21.8842 12.6545 22.3035 13.0587C22.7242 13.4644 22.7285 14.1242 22.3135 14.5312L16.7898 19.9782C16.5816 20.1838 16.3091 20.2866 16.0353 20.288",
    fill: "#3C7CF6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection1);
export default __webpack_public_path__ + "static/media/section-1.30964bfb306e2a05c9a5f9bcc923028b.svg";
export { ForwardRef as ReactComponent };